module.exports = [{
      plugin: require('/opt/build/repo/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('/opt/build/repo/node_modules/gatsby-plugin-google-analytics/gatsby-browser'),
      options: {"plugins":[],"trackingId":"UA-121776060-2","head":false,"anonymize":true,"respectDNT":true},
    },{
      plugin: require('/opt/build/repo/gatsby-browser'),
      options: {"plugins":[]},
    }]
